export default "__VITE_ASSET__CmsFLz$s__"